import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "@material-ui/core";
import SuccessModal from "../Popups/SuccessModal";
import ThankYou from "./Pages/ThankYou";
import Submitted from "./Pages/Submitted";
import DashboardLinkBank from "../../linkbank/DashboardLinkBank";
import * as actions from "../../../state/actions/onboarding";
import { Md, withMobile, Xs, withBreakpoint } from "../../common";
import { BannerCritical } from "../Banner";
import CurrentBalance from "../Components/CurrentBalance";
import AvailableCredit from "../Components/AvailableCredit";
import CreditScore from "../Components/CreditScore";

const dashboardUrl = `${process.env.REACT_APP_DASHBOARD_HOST}/dashboard`;

const containerHeight = "150px";

const DashboardContent = ({
  componentProps,
  history,
  getDecision,
  decisionStep,
  breakpointContext
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPending, setShowPending] = useState(false);
  const [showAccepted, setShowAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loadingDecision, setLoadingDecision] = useState(false);
  const { isMobile } = withMobile();

  useEffect(() => {
    if (decisionStep.approved === true) {
      window.onbeforeunload = null;
      window.location = dashboardUrl;
    } else if (decisionStep.approved === false) {
      setShowSuccess(true);
    } else if (decisionStep.pending === true) {
      // setShowPending(true);
      history.push("/decision");
    }
    setLoadingDecision(false);
  }, [decisionStep]);

  const handleSubmission = e => {
    setLoadingDecision(true);
    e.preventDefault();
    console.log("Submitting application from onboarding dashboard");
    getDecision();
  };

  const renderDefault = () => {
    return [
      <>
        <BannerCritical
          title="Please complete this step to unlock your TomoCredit card and start building your credit!"
          color={"#BB0000"}
        />
        <Xs to="md">
          <div className="flex flex-wrap">
            <CurrentBalance className="flex w-1/2  mt-4 pr-2" />
            <AvailableCredit className="flex w-1/2 mt-4" />
            <CreditScore className="w-full mt-4" />
          </div>
        </Xs>
        <Md>
          <div className="flex flex-col self-center mx-auto">
            <div
              className="flex flex-row -mx-2 mb-2"
              style={{ minHeight: containerHeight }}
            >
              <CurrentBalance className="flex-auto px-2" />
              <AvailableCredit className="flex-auto px-2" />
              <CreditScore className="flex-auto px-2" />
            </div>
          </div>
        </Md>

        <div className="flex flex-col">
          <DashboardLinkBank
            handleSubmission={handleSubmission}
            loadingDecision={loadingDecision}
            submitting={submitting}
            history={history}
            {...componentProps}
          />
        </div>
      </>
    ];
  };
  const renderAccepted = () => {
    return [
      <>
        <Modal
          open={showAccepted}
          // onClose={() => setShowAccepted(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...(!breakpointContext.isBelow("xl") &&
              !isMobile() && { marginLeft: "240px" })
          }}
        >
          <SuccessModal close={() => setShowAccepted(false)} />
        </Modal>

        <div className="flex flex-col">
          <DashboardLinkBank
            handleSubmission={handleSubmission}
            submitting={submitting}
            history={history}
            {...componentProps}
          />
        </div>
      </>
    ];
  };
  if (showAccepted) {
    return renderAccepted();
  } else if (showSuccess) {
    return <Submitted />;
  } else if (showPending) {
    return <ThankYou />;
  } else {
    return renderDefault();
  }
};

export default compose(
  connect(
    state => ({
      user: state.register.user,
      networkingError: state.register.networkingError,
      complete: state.register.applicationProgress.address,
      meetsBalanceThreshold: state.register.meetsBalanceThreshold,
      decisionStep: state.register.decision,
      processingApplication: state.register.processingApplication
    }),
    actions
  ),
  withRouter,
  withBreakpoint,
  withMobile
)(DashboardContent);
